import type { Constructor } from '@/type-utils';
import { mocked } from '@/configs';
import type { SearchSuggestionsService } from './SearchSuggestionsService';
import MockService, { MockState, ServiceMock } from '../MockService';

const initialState = {};

/**
 * Mock for the {@link SearchSuggestionsService}.
 */
export default class SearchSuggestionsServiceMock extends ServiceMock<SearchSuggestionsService> {
  protected _state;

  /** @inheritdoc */
  public get state(): MockState {
    return this._state;
  }

  /** @inheritdoc */
  public getMock(): SearchSuggestionsService {
    return MockService.getMockOf(
      this.service
    ) as unknown as SearchSuggestionsService;
  }

  /**
   * The constructor to initialize the mocks.
   *  @param service - The service for this mock, used to remove a circular dependency.
   */
  public constructor(private service: Constructor<SearchSuggestionsService>) {
    super();
    this._state = new MockState(initialState);
    this.initializeMockedMembers(this.service);
  }

  /** @inheritdoc */
  protected initializeMockedMembers(
    service: Constructor<SearchSuggestionsService>
  ): void {
    const mockEnabled: boolean = mocked.SearchSuggestionsService;

    MockService.mockService(
      mockEnabled,
      service,
      {
        getSuggestionsBySearchTerms: async (_term, _options) => {
          const MOCK_SEARCH_SUGGESTIONS = await import(
            /* webpackChunkName: "mock_search_suggestions" */
            /* webpackExports: "default" */
            '@/services/models/SearchSuggestions/mocks/MOCK_SEARCH_SUGGESTIONS'
          ).then((module) => module.default);
          return MOCK_SEARCH_SUGGESTIONS;
        }
      },
      {},
      this.state
    );
  }
}
